import Loader from "./Loader";
import Taptop from "./TapTop";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import React, { Fragment, useState, useEffect } from "react";
import ThemeCustomize from "../Layout/ThemeCustomizer";
import { ToastContainer } from "react-toastify";
import { useContext } from "react";
import { loadingPanel } from "../CommonComponents/CommonFunction";
import CustomizerContext from "../_helper/Customizer";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import AnimationThemeContext from "../_helper/AnimationTheme";
import { useSelector } from "react-redux";
import { useAuth, AuthContext } from "oidc-react";
import { setApiToken } from "./../_helper/api_helper";
import ErrorBoundary from "../ErrorBoundry";
import { Alert, Button } from "@mui/material";
import EmployeeSignatureModal from "../CommonComponents/EmployeeSignature/EmployeeSignatureModal";
import { advanceSearch } from "../_helper/services/advanceSearchv2";
import { getUserId, getUserRole } from "../_helper/helper";
import { Col, Row } from "reactstrap";
import { Btn } from "../AbstractElements";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/pro-duotone-svg-icons";
// import { store } from "emoji-mart";
// import { parse } from "@fortawesome/fontawesome-svg-core";
const AppLayout = ({ children, classNames, ...rest }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { userManager, userData } = useAuth();
  const id = getUserId(userData);
  const role = getUserRole(userData);
  const currentRole = sessionStorage.getItem("currentRole");
  const { isLoading } = useContext(AuthContext);
  const [signatureData, setSignatureData] = useState([]);
  const [openEditModal, setOpenEditModal] = useState({
    show: false,
    signatureData: {},
    operation: "",
  });
  const { animation } = useContext(AnimationThemeContext);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const { StoredUserConfiguration, storedTheme } = useSelector(
    (state) => state?.ThemeCustomizerReducer
  );
  const { isEmployeeSignatureLoading, signatures, isSignatureFetching } =
    useSelector((state) => state?.EmployeeSignatureReducer);
  const { sidebar_types } = useContext(CustomizerContext);
  const queryData = location?.search?.split("=")[1]?.toString();
  const settings1 =
    storedTheme?.settings?.sidebar_setting ||
    storedTheme?.settings?.sidebar.type ||
    "compact-wrapper" ||
    queryData;
  const sidebar_types1 =
    storedTheme?.settings?.sidebar.type || "default-sidebar" || sidebar_types;
  const animationTheme =
    animation ||
    StoredUserConfiguration?.router_animation ||
    storedTheme?.router_animation ||
    "fadeIn";
  userManager
    .signinRedirectCallback()
    .then((user) => {
      if (user) {
        // if (user.profile.role !== "user" && user.profile.Application !== "HR") {
        //   // window.location.replace("/unauthorized");
        // }
        //else {
        localStorage.setItem("jwt_access_token", user.access_token);
        sessionStorage.setItem("jwt_access_token", user?.access_token);

        localStorage.setItem("role", user.profile.role);
        localStorage.setItem("authStatus", "SignedIn");
        setApiToken(user.access_token);
        if (localStorage.getItem("redirect-to")) {
          const redirectTo = localStorage.getItem("redirect-to");
          localStorage.removeItem("redirect-to");
          navigate(redirectTo);
        }
        // }
      }
    })
    .catch((err) => {
      // history.push({ 'pathname': '/employeeManage' })
      // history.push({ pathname: window.location.pathname });
      // window.location.replace("/login");
    });

  const getSignature = async () => {
    const id = getUserId(userData);
    const role = getUserRole(userData);
    const currentRole = sessionStorage.getItem("currentRole");
    const payload = {
      id: "employeeSign",
      location: "global",
      tableName: "vw_empl_portal_EmployeeSigns",
      searchParams: "[]",
      columns: "*",
      pageNumber: 1,
      pageSize: 999,
      sortData: "",
      additionalWhere: `EmployeeId = ${userData?.profile?.EmployeeID} and actingRole = '${currentRole}'`,
      qID: 0,
    };
    const response = await advanceSearch(
      payload,
      "vw_empl_portal_EmployeeSigns"
    );
    if (response?.results) {
      setSignatureData(response?.results);
    }
  };

  useEffect(() => {
    if (userData && currentRole) {
      getSignature();
    }
  }, [userData, currentRole, isEmployeeSignatureLoading]);

  useEffect(() => {
    if (isLoading === false && (userData == null || userData.expired)) {
      localStorage.setItem("redirect-to", location.pathname);
      userManager.signinRedirect();
    } else if (isLoading == false && userData) {
      if (localStorage.getItem("redirect-to")) {
        const redirectTo = localStorage.getItem("redirect-to");
        localStorage.removeItem("redirect-to");
        navigate(redirectTo);
      }
    }
  }, [userData, isLoading]);
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsDataLoaded(true);
    }, 100);
    return () => {
      clearTimeout(timer);
    };
  }, []);
  if (!userData?.access_token) return null;

  const handleAddSignature = () => {
    setOpenEditModal({ show: true, signatureData: {}, operation: "add" });
  };

  return (
    <Fragment>
      <Loader />
      <Taptop />
      <div
        className={`page-wrapper ${sidebar_types1} ${settings1}`}
        id="pageWrapper"
      >
        <Header />
        <div className="page-body-wrapper horizontal-menu">
          <Sidebar />
          <TransitionGroup>
            {/* {isLoading && loadingPanel()} */}
            {isDataLoaded && (
              <CSSTransition
                // key={location.key}
                in={true}
                timeout={300}
                // classNames="my-transition"
                classNames={animationTheme}
                unmountOnExit
                // mountOnEnter
                appear
                mountOnEnter
              >
                <div className="page-body" style={{ overflow: "auto" }}>
                  <ErrorBoundary>
                    {
                      (signatureData && signatureData.length > 0) ||
                        [
                          "BenefitsGovernmentWideManagement",
                          "BenefitsDepartmentManagement",
                        ].includes(currentRole) ? null : (
                        <Row>
                          {["/transactions/blanket-assign", "/dashboard/certificate-tracking"].some((p) =>
                            window.location.pathname.includes(p)
                          ) ? null
                            :
                            <Col md="12" className="p-3">
                              <Alert severity="error">
                                {
                                  "You don't have a digital signature. Please click the button below to create a new one. This signature will be used for Authorization, Approvals etc."
                                }
                                <Col md="12" className="mt-2">
                                  {/* <Btn
                            attrBtn={{
                              color: "primary",
                              startIcon: <i className="fas fa-plus"></i>,
                              onClick: (e) => {
                                navigate('/signature-management')
                              },
                            }}
                          >
                            <FontAwesomeIcon icon={faSave} />{" "}
                            Add Signature

                          </Btn> */}
                                  <Btn
                                    attrBtn={{
                                      color: "primary",
                                      onClick: (e) => {
                                        handleAddSignature();
                                      },
                                    }}
                                  >
                                    <FontAwesomeIcon icon={faPlus} /> &nbsp; Add
                                    Signature
                                  </Btn>
                                </Col>
                              </Alert>
                            </Col>
                          }
                        </Row>
                      )
                      // <div style={{ display: 'flex', fontWeight: 'bold', textTransform: 'lowercase', textDecoration: 'underline', cursor: 'pointer' }}>
                      //   <p style={{ color: 'orange' }} className="d-flex align-items-center">
                      //     {`The ${role} authorized signature is missing.`}
                      //   </p>
                      //   <Button onClick={handleAddSignature} variant="text">Click here to add it.</Button>
                      // </div>
                    }

                    <Outlet />
                  </ErrorBoundary>
                  {openEditModal.show && (
                    <EmployeeSignatureModal
                      operation={openEditModal.operation}
                      openCanvas={openEditModal.show}
                      signatureData={openEditModal.signatureData}
                      setOpenCanvas={() =>
                        setOpenEditModal({
                          show: false,
                          signatureData: {},
                          operation: "",
                        })
                      }
                      isEditMode={true}
                    />
                  )}
                </div>
              </CSSTransition>
            )}
          </TransitionGroup>
          <Footer />
        </div>
      </div>
      <ThemeCustomize />
      <ToastContainer />
    </Fragment>
  );
};
export default AppLayout;
